// Support both the current API and older responses containing only numeric status.
const statusCodes = {
  0: 'REJECTED', 1: 'CREDITED', 2: 'CONFIRMING', 3: 'CONFIRMING',
  4: 'FROZEN', 5: 'CHECKING', 6: 'REVIEW_PENDING'
}
export function depositDisplayStatus(row) {
  if (row.displayStatus) return row.displayStatus
  if (row.status == null || row.status === '') return 'PROCESSING'
  const status = Number(row.status)
  if (String(row.assetType).toUpperCase() === 'HKD' && status === 3) return 'REVIEW_PENDING'
  return statusCodes[status] || 'PROCESSING'
}
